module.exports = __webpack_public_path__ + "static/media/stephen_dev_project.c1b0c6ee.png";